export default __webpack_public_path__ + "static/media/2022-06-01_high_res_logo.ec9ef786.png";